import { Certificate, DropdownOption } from './types';

export const mapCertificate = (certificate: Certificate): DropdownOption => ({
  label: certificate.Name,
  value: certificate.Id,
});
